module.exports = __webpack_public_path__ + "static/kenda-logo-7eb8d7e212153d369b28908d1ea2e17e.png";